import { render, staticRenderFns } from "./SwitchTeams.vue?vue&type=template&id=1af1fc68&"
import script from "./SwitchTeams.vue?vue&type=script&lang=js&"
export * from "./SwitchTeams.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports